import { Alert, Button, Card, Center, Stack, Text, Title } from '@mantine/core';
import { IconShieldCheck } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import { useAuth, useCurrentUser } from '@/auth/AuthProvider';
import { PortalMark } from '@/features/portal/PortalMark';
import { Logo } from '@/layout/Logo';
import { notifySuccess } from '@/lib/notify';
import { homeFor, loginFor } from '@/lib/paths';
import { ChangePasswordForm } from './ChangePasswordForm';

/** Shown when an administrator issued a temporary password: nothing else is reachable until it is replaced. */
export function ChangePasswordPage() {
  const user = useCurrentUser();
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <Center mih="100dvh" p="lg">
      <Stack w="100%" maw={440} gap="lg">
        {user.userType === 'exporter' ? <PortalMark /> : <Logo />}
        <Card shadow="sm">
          <Stack gap="md">
            <Stack gap={4}>
              <Title order={3}>Set a new password</Title>
              <Text c="dimmed" fz="sm">
                Signed in as {user.email}.
              </Text>
            </Stack>
            {user.mustChangePassword && (
              <Alert color="brand" variant="light" icon={<IconShieldCheck size={18} />}>
                You signed in with a temporary password. Choose your own password to continue.
              </Alert>
            )}
            <ChangePasswordForm
              currentLabel={user.mustChangePassword ? 'Temporary password' : 'Current password'}
              onDone={() => {
                notifySuccess('Your password has been updated.');
                navigate(homeFor(user), { replace: true });
              }}
            />
          </Stack>
        </Card>
        <Button variant="subtle" color="gray" onClick={() => void logout().then(() => navigate(loginFor(user), { replace: true }))}>
          Sign out
        </Button>
      </Stack>
    </Center>
  );
}
